var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.75 4.893a4.25 4.25 0 0 1-1.25 2.89L13.785 10.5a4.24 4.24 0 0 1-3.018 1.25h-.004A4.27 4.27 0 0 1 6.5 7.363a.625.625 0 0 1 1.25.035 3.017 3.017 0 0 0 5.148 2.218l2.715-2.714a3.018 3.018 0 0 0-4.268-4.268l-.86.859a.625.625 0 0 1-.883-.884l.859-.859a4.27 4.27 0 0 1 7.289 3.143M7.516 12.505l-.86.86a3 3 0 0 1-2.14.885 3.018 3.018 0 0 1-2.132-5.152l2.71-2.714a3.018 3.018 0 0 1 5.156 2.218.625.625 0 1 0 1.25.036A4.29 4.29 0 0 0 10.25 5.5a4.27 4.27 0 0 0-6.037 0L1.5 8.215a4.267 4.267 0 0 0 6.031 6.035l.86-.86a.625.625 0 0 0-.875-.885"
  })));
};
export default SvgLink;